import { TEstimate } from '@entities/eventJournal/model/types';

interface IUseGetEstimateNameParams {
    estimatesData: TEstimate[];
    estimateId: TEstimate['id'];
    isSuccess: boolean;
}

export const getEstimateName = ({
    estimatesData,
    estimateId,
    isSuccess = true,
}: IUseGetEstimateNameParams) => {
    if (isSuccess) {
        return estimatesData?.find((estimate) => estimate.id === estimateId)?.name;
    }
    return null;
};
